module.exports = __webpack_public_path__ + "media/images/promo/ecomm-callout-d1c4204909027ddd320ff4e08a1c7084.jpg";